export default __webpack_public_path__ + "static/media/cryptocurrency.1548aced.png";